import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { withTranslation, useTranslation, I18nextProvider } from 'react-i18next';
import isEmpty from 'lodash/isEmpty';
import isNumber from 'lodash/isNumber';
import Modal from '@hsl-fi/modal';
import Icon, { defaultColors } from '@digitransit-component/digitransit-component-icon';
import { createInstance } from 'i18next';

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$2 = ".styles_generic-table__AmCUO > .styles_row__Iooox {\n  display: flex;\n}\n\n.styles_generic-table__label-container__ItaRd {\n  font-size: 0.8rem;\n  margin-top: 3px;\n  color: #666;\n  height: 16px;\n  max-width: 62.5rem;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.styles_favourite-icon-table-column__CzU8B {\n  cursor: pointer;\n  flex: 1;\n  align-items: center;\n  padding: 0;\n  background: #fff;\n  float: left;\n  height: 50px;\n  margin: 0;\n  line-height: 1;\n  text-align: center;\n  font-size: 17px;\n  border-top: solid 1px #ddd;\n  border-bottom: solid 1px #ddd;\n  border-right: solid 1px #ddd;\n  border-left: none;\n}\n.styles_favourite-icon-table-column__CzU8B.styles_place__P6Ks- svg {\n  width: 24px;\n  height: 24px;\n}\n.styles_favourite-icon-table-column__CzU8B.styles_work__XL3SA svg {\n  width: 20px;\n  height: 20px;\n}\n.styles_favourite-icon-table-column__CzU8B.styles_home__xYJbW svg, .styles_favourite-icon-table-column__CzU8B.styles_school__K3-Yy svg, .styles_favourite-icon-table-column__CzU8B.styles_sport__i0xXI svg, .styles_favourite-icon-table-column__CzU8B.styles_shopping__eQ3br svg {\n  width: 18px;\n  height: 18px;\n}\n.styles_favourite-icon-table-column__CzU8B:active, .styles_favourite-icon-table-column__CzU8B:hover, .styles_favourite-icon-table-column__CzU8B:focus,\n.styles_favourite-icon-table-column__CzU8B .styles_selected-icon__PMTfC {\n  background: #333;\n  color: #fff;\n}\n\n.styles_favourite-icon-table-column__CzU8B:first-child {\n  border-left: solid 1px #ddd;\n  border-top-left-radius: 5px;\n  border-bottom-left-radius: 5px;\n}\n\n.styles_favourite-icon-table-column__CzU8B:last-child {\n  border-top-right-radius: 5px;\n  border-bottom-right-radius: 5px;\n}\n\n.styles_favourite-icon-table-column__CzU8B.styles_selected-icon__PMTfC {\n  background: #333;\n  color: #fff;\n}";
var styles$2 = {"generic-table":"styles_generic-table__AmCUO","row":"styles_row__Iooox","generic-table__label-container":"styles_generic-table__label-container__ItaRd","favourite-icon-table-column":"styles_favourite-icon-table-column__CzU8B","place":"styles_place__P6Ks-","work":"styles_work__XL3SA","home":"styles_home__xYJbW","school":"styles_school__K3-Yy","sport":"styles_sport__i0xXI","shopping":"styles_shopping__eQ3br","selected-icon":"styles_selected-icon__PMTfC"};
styleInject(css_248z$2);

/* eslint sort-keys: "error" */
const translations = {
  de: {
    translation: {
      cancel: 'Abbrechen',
      'choose-icon': 'Wählen Sie ein Symbol für diesen Ort',
      'close-favourite-modal': 'Favoriten-Dialog schließen',
      'edit-place': 'Ort bearbeiten',
      'favourite-modal-on-add-new': 'Neuen Favoriten hinzufügen',
      'favourite-modal-on-edit': 'Favorit bearbeiten: {{favourite.name}}',
      'input-placeholder': 'Einen Namen für Ort setzen (optional)',
      save: 'Speichern',
      'save-place': 'Favorit speichern'
    }
  },
  en: {
    translation: {
      cancel: 'Cancel',
      'cannot-save-place': 'Cannot save a place without address or icon',
      'choose-icon': "Select the place's icon",
      'close-favourite-modal': 'Close the favourite modal',
      'edit-place': 'Edit place',
      'favourite-modal-on-add-new': 'Add a new favorite',
      'favourite-modal-on-edit': 'Editing favourite: {{favourite.name}}',
      home: 'home',
      'input-placeholder': 'Give the name a place (optional)',
      place: 'a place',
      'required-text': 'required field',
      save: 'Save',
      'save-place': 'Save place',
      school: 'school',
      shopping: 'shopping',
      sport: 'sport',
      work: 'work'
    }
  },
  fi: {
    translation: {
      cancel: 'Peruuta',
      'cannot-save-place': 'Paikkaa ilman osoitetta tai ikonia ei voida tallentaa',
      'choose-icon': 'Valitse paikan kuvake',
      'close-favourite-modal': 'Sulje suosikkimodaali',
      'edit-place': 'Muokkaa paikkaa',
      'favourite-modal-on-add-new': 'Lisää uusi suosikki',
      'favourite-modal-on-edit': 'Muokkaa suosikkia {{favourite.name}}',
      home: 'koti',
      'input-placeholder': 'Anna paikalle nimi (vapaaehtoinen)',
      place: 'paikka',
      'required-text': 'pakollinen kenttä',
      save: 'Tallenna',
      'save-place': 'Tallenna paikka',
      school: 'koulu',
      shopping: 'ostokset',
      sport: 'urheilu',
      work: 'työ'
    }
  },
  ga: {
    translation: {
      cancel: 'Cealaigh',
      'cannot-save-place': 'Ní féidir áit a shábháil gan seoladh nó deilbhín',
      'choose-icon': 'Roghnaigh deilbhín na háite',
      'close-favourite-modal': 'Dún modal na gceanán',
      'edit-place': 'Cuir áit in eagar',
      'favourite-modal-on-add-new': 'Cuir ceanán nua leis',
      'favourite-modal-on-edit': 'Ag cur in eagar: {{favourite.name}}',
      home: 'baile',
      'input-placeholder': 'Tabhair ainm don áit (roghnach)',
      place: 'áit',
      'required-text': 'réimse riachtanach',
      save: 'Sábháil',
      'save-place': 'Sábháil an áit',
      school: 'scoil',
      shopping: 'siopadóireacht',
      sport: 'spórt',
      work: 'obair'
    }
  },
  pl: {
    translation: {
      cancel: 'Anuluj',
      'cannot-save-place': 'Nie można zapisać miejsca bez nazwy lub ikony',
      'choose-icon': 'Wybierz ikonę miejsca',
      'close-favourite-modal': 'Zamknij modal ulubionych',
      'edit-place': 'Edytuj miejsce',
      'favourite-modal-on-add-new': 'Dodaj ulubione miejsce',
      'favourite-modal-on-edit': 'Edycja ulubionego miejsca: {{favourite.name}}',
      home: 'dom',
      'input-placeholder': 'Nadaj nazwę miejscu (opcjonalne)',
      place: 'miejsce',
      'required-text': 'pole wymagane',
      save: 'Zapisz',
      'save-place': 'Zapisz miejsce',
      school: 'szkoła',
      shopping: 'zakupy',
      sport: 'sport',
      work: 'praca'
    }
  },
  sv: {
    translation: {
      cancel: 'Avbryt',
      'cannot-save-place': 'Det går inte att spara en plats utan adress eller ikon',
      'choose-icon': 'Välj platsens ikon',
      'close-favourite-modal': 'Stäng favoritmodalen',
      'edit-place': 'Redigera plats',
      'favourite-modal-on-add-new': 'Lägg till ny favorit',
      'favourite-modal-on-edit': 'Redigera platsen: {{favourite.name}}',
      home: 'hem',
      'input-placeholder': 'Ange platsens namn (frivilligt)',
      place: 'en plats',
      'required-text': 'obligatoriskt fält',
      save: 'Spara',
      'save-place': 'Spara plats',
      school: 'skola',
      shopping: 'shoppa',
      sport: 'sport',
      work: 'arbete'
    }
  }
};

const i18n = createInstance({
  fallbackLng: 'en',
  // debug: true,
  resources: translations,
  defaultNS: 'translation',
  react: {
    useSuspense: true
  }
});
i18n.init();

var css_248z$1 = ".desktop_favourite-modal-desktop-container__PV5YQ {\n  display: flex;\n  flex-direction: column;\n}\n.desktop_favourite-modal-desktop-container__PV5YQ .desktop_favourite-modal-desktop-top__Md0-E {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n}\n.desktop_favourite-modal-desktop-container__PV5YQ .desktop_favourite-modal-desktop-top__Md0-E .desktop_favourite-modal-desktop-header__ko87c {\n  width: 100%;\n  font-size: 18px;\n  font-weight: var(--font-weight-medium);\n  line-height: 1.33;\n  letter-spacing: -0.6px;\n  color: #333;\n  margin-bottom: 25px;\n}\n.desktop_favourite-modal-desktop-container__PV5YQ .desktop_favourite-modal-desktop-main__lkOF7 {\n  text-align: left;\n  margin-bottom: 27px;\n}\n.desktop_favourite-modal-desktop-container__PV5YQ .desktop_favourite-modal-desktop-main__lkOF7 .desktop_favourite-modal-desktop-location-search__QO5vN {\n  margin-bottom: 9px;\n}\n.desktop_favourite-modal-desktop-container__PV5YQ .desktop_favourite-modal-desktop-main__lkOF7 .desktop_favourite-modal-desktop-name__qAHli .desktop_favourite-modal-desktop-input__GPKca {\n  display: flex;\n  position: relative;\n  width: 100%;\n  height: 44px;\n  font-family: inherit;\n  border-radius: 5px;\n  border: solid 1px #888;\n  background-color: #fff;\n  padding-left: 20px;\n  font-size: 15px;\n  line-height: 1.2;\n  letter-spacing: -0.5px;\n  color: #333;\n  box-sizing: border-box;\n  appearance: none;\n}\n.desktop_favourite-modal-desktop-container__PV5YQ .desktop_favourite-modal-desktop-main__lkOF7 .desktop_favourite-modal-desktop-name__qAHli .desktop_favourite-modal-desktop-input__GPKca::placeholder {\n  color: #666;\n}\n.desktop_favourite-modal-desktop-container__PV5YQ .desktop_favourite-modal-desktop-main__lkOF7 .desktop_favourite-modal-desktop-name__qAHli .desktop_favourite-modal-desktop-input__GPKca:focus {\n  background: #fff;\n  outline: none;\n  border: 1px solid var(--color);\n  box-shadow: 0 0 2px 1px var(--hover-color);\n  appearance: none;\n}\n.desktop_favourite-modal-desktop-container__PV5YQ .desktop_favourite-modal-desktop-text__QuGLs {\n  font-size: 16px;\n  font-weight: var(--font-weight-medium);\n  letter-spacing: -0.53px;\n  color: #333;\n  margin: 0 0 11px 0;\n  padding: 0;\n}\n.desktop_favourite-modal-desktop-container__PV5YQ .desktop_favourite-modal-desktop-icons__lYHGt {\n  margin-bottom: 30px;\n}\n.desktop_favourite-modal-desktop-container__PV5YQ .desktop_icons-container__qsM8T {\n  border: none;\n  margin: 0;\n  padding: 0;\n}\n.desktop_favourite-modal-desktop-container__PV5YQ .desktop_favourite-modal-desktop-buttons__CmnaN {\n  display: flex;\n  flex-direction: column;\n}\n.desktop_favourite-modal-desktop-container__PV5YQ .desktop_favourite-modal-desktop-buttons__CmnaN .desktop_favourite-modal-desktop-button__DS4p5 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  width: 100%;\n  height: 50px;\n  font-size: 18px;\n  font-family: inherit;\n  font-weight: var(--font-weight-medium);\n  letter-spacing: -0.5px;\n  background: var(--color);\n  color: #fff;\n  line-height: 0;\n  text-align: center;\n  padding: 0;\n  margin: 0;\n  border-width: 0;\n  transition: background-color 300ms ease-out;\n  border-radius: 25px;\n  cursor: pointer;\n}\n.desktop_favourite-modal-desktop-container__PV5YQ .desktop_favourite-modal-desktop-buttons__CmnaN .desktop_favourite-modal-desktop-button__DS4p5.desktop_save__3FjAd:active, .desktop_favourite-modal-desktop-container__PV5YQ .desktop_favourite-modal-desktop-buttons__CmnaN .desktop_favourite-modal-desktop-button__DS4p5.desktop_save__3FjAd:focus, .desktop_favourite-modal-desktop-container__PV5YQ .desktop_favourite-modal-desktop-buttons__CmnaN .desktop_favourite-modal-desktop-button__DS4p5.desktop_save__3FjAd:hover {\n  border-color: var(--hover-color);\n  background: var(--hover-color);\n  color: #fff;\n}\n.desktop_favourite-modal-desktop-container__PV5YQ .desktop_favourite-modal-desktop-buttons__CmnaN .desktop_favourite-modal-desktop-button__DS4p5.desktop_save__3FjAd.desktop_disabled__TxliP {\n  background: #bbb;\n}\n.desktop_favourite-modal-desktop-container__PV5YQ .desktop_favourite-modal-desktop-buttons__CmnaN .desktop_favourite-modal-desktop-button__DS4p5.desktop_save__3FjAd.desktop_disabled__TxliP:active {\n  background: #bbb;\n}\n.desktop_favourite-modal-desktop-container__PV5YQ .desktop_favourite-modal-desktop-buttons__CmnaN .desktop_favourite-modal-desktop-button__DS4p5.desktop_edit__OWrRz {\n  margin-top: 9px;\n  background: #fff;\n  border: solid 1px var(--color);\n  color: var(--color);\n}\n.desktop_favourite-modal-desktop-container__PV5YQ .desktop_favourite-modal-desktop-buttons__CmnaN .desktop_favourite-modal-desktop-button__DS4p5.desktop_edit__OWrRz:active, .desktop_favourite-modal-desktop-container__PV5YQ .desktop_favourite-modal-desktop-buttons__CmnaN .desktop_favourite-modal-desktop-button__DS4p5.desktop_edit__OWrRz:hover {\n  border-color: var(--hover-color);\n  background-color: #fff;\n  color: var(--hover-color);\n}\n\n.desktop_sr-only__Xy3rC:not(:focus, :active) {\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}";
var styles$1 = {"favourite-modal-desktop-container":"desktop_favourite-modal-desktop-container__PV5YQ","favourite-modal-desktop-top":"desktop_favourite-modal-desktop-top__Md0-E","favourite-modal-desktop-header":"desktop_favourite-modal-desktop-header__ko87c","favourite-modal-desktop-main":"desktop_favourite-modal-desktop-main__lkOF7","favourite-modal-desktop-location-search":"desktop_favourite-modal-desktop-location-search__QO5vN","favourite-modal-desktop-name":"desktop_favourite-modal-desktop-name__qAHli","favourite-modal-desktop-input":"desktop_favourite-modal-desktop-input__GPKca","favourite-modal-desktop-text":"desktop_favourite-modal-desktop-text__QuGLs","favourite-modal-desktop-icons":"desktop_favourite-modal-desktop-icons__lYHGt","icons-container":"desktop_icons-container__qsM8T","favourite-modal-desktop-buttons":"desktop_favourite-modal-desktop-buttons__CmnaN","favourite-modal-desktop-button":"desktop_favourite-modal-desktop-button__DS4p5","save":"desktop_save__3FjAd","disabled":"desktop_disabled__TxliP","edit":"desktop_edit__OWrRz","sr-only":"desktop_sr-only__Xy3rC"};
styleInject(css_248z$1);

/* eslint-disable jsx-a11y/click-events-have-key-events */
const DesktopModal = ({
  headerText,
  autosuggestComponent,
  inputPlaceholder,
  specifyName,
  name,
  chooseIconText,
  favouriteIconTable,
  saveFavourite,
  saveText,
  canSave,
  isEdit,
  cancelText,
  cancelSelected,
  color,
  hoverColor,
  savePlaceText,
  cantSaveText,
  requiredText,
  fontWeights
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles$1['favourite-modal-desktop-container'],
    style: {
      '--color': `${color}`,
      '--hover-color': `${hoverColor}`,
      '--font-weight-medium': fontWeights.medium
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$1['favourite-modal-desktop-top']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$1['favourite-modal-desktop-header']
  }, headerText)), /*#__PURE__*/React.createElement("div", {
    className: styles$1['favourite-modal-desktop-main']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$1['favourite-modal-desktop-location-search']
  }, autosuggestComponent), /*#__PURE__*/React.createElement("div", {
    className: styles$1['favourite-modal-desktop-name']
  }, /*#__PURE__*/React.createElement("input", {
    "aria-label": inputPlaceholder,
    className: styles$1['favourite-modal-desktop-input'],
    value: name,
    placeholder: inputPlaceholder,
    onChange: specifyName
  }))), /*#__PURE__*/React.createElement("fieldset", {
    className: styles$1['icons-container']
  }, /*#__PURE__*/React.createElement("legend", {
    className: styles$1['favourite-modal-desktop-text']
  }, chooseIconText, /*#__PURE__*/React.createElement("p", {
    className: styles$1['sr-only']
  }, requiredText)), /*#__PURE__*/React.createElement("div", {
    className: styles$1['favourite-modal-desktop-icons']
  }, favouriteIconTable)), /*#__PURE__*/React.createElement("div", {
    className: styles$1['favourite-modal-desktop-buttons']
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: `${styles$1['favourite-modal-desktop-button']} ${styles$1.save} ${canSave() ? '' : styles$1.disabled}`,
    onClick: saveFavourite,
    "aria-label": `${canSave() ? savePlaceText : cantSaveText}`,
    "aria-disabled": !canSave()
  }, saveText), isEdit && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: `${styles$1['favourite-modal-desktop-button']} ${styles$1.edit} ${canSave() ? '' : styles$1.disabled}`,
    onClick: cancelSelected
  }, cancelText)));
};
process.env.NODE_ENV !== "production" ? DesktopModal.propTypes = {
  headerText: PropTypes.string.isRequired,
  autosuggestComponent: PropTypes.node.isRequired,
  inputPlaceholder: PropTypes.string.isRequired,
  specifyName: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  chooseIconText: PropTypes.string.isRequired,
  favouriteIconTable: PropTypes.node.isRequired,
  saveFavourite: PropTypes.func.isRequired,
  saveText: PropTypes.string.isRequired,
  canSave: PropTypes.func.isRequired,
  isEdit: PropTypes.bool,
  cancelText: PropTypes.string.isRequired,
  cancelSelected: PropTypes.func,
  color: PropTypes.string.isRequired,
  hoverColor: PropTypes.string.isRequired,
  savePlaceText: PropTypes.string.isRequired,
  cantSaveText: PropTypes.string.isRequired,
  requiredText: PropTypes.string.isRequired,
  fontWeights: PropTypes.shape({
    medium: PropTypes.number.isRequired
  }).isRequired
} : void 0;
DesktopModal.defaultProps = {
  isEdit: false,
  cancelSelected: () => ({})
};

var css_248z = ".mobile_favourite-modal-mobile-container__KaYun {\n  display: flex;\n  flex-direction: column;\n}\n.mobile_favourite-modal-mobile-container__KaYun .mobile_favourite-modal-mobile-top__SkpP4 {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  border-bottom: 1px solid #ddd;\n  margin-bottom: 30px;\n}\n.mobile_favourite-modal-mobile-container__KaYun .mobile_favourite-modal-mobile-top__SkpP4 .mobile_favourite-modal-mobile-header__dZlvY {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: inherit;\n  font-size: 18px;\n  font-weight: var(--font-weight-medium);\n  letter-spacing: -0.6px;\n  text-align: center;\n  color: #333;\n  margin-bottom: 37px;\n}\n.mobile_favourite-modal-mobile-container__KaYun .mobile_favourite-modal-mobile-main__VeUUV {\n  text-align: left;\n  margin-bottom: 28px;\n}\n.mobile_favourite-modal-mobile-container__KaYun .mobile_favourite-modal-mobile-main__VeUUV .mobile_favourite-modal-mobile-location-search__fTM46 {\n  margin-bottom: 9px;\n}\n.mobile_favourite-modal-mobile-container__KaYun .mobile_favourite-modal-mobile-main__VeUUV .mobile_favourite-modal-mobile-input__yYUMl {\n  display: flex;\n  position: relative;\n  width: 100%;\n  height: 44px;\n  font-family: inherit;\n  border-radius: 5px;\n  border: solid 1px #888;\n  background-color: #fff;\n  padding-left: 20px;\n  font-size: 16px;\n  line-height: 1.2;\n  letter-spacing: -0.5px;\n  color: #333;\n  box-sizing: border-box;\n  appearance: none;\n}\n.mobile_favourite-modal-mobile-container__KaYun .mobile_favourite-modal-mobile-main__VeUUV .mobile_favourite-modal-mobile-input__yYUMl:focus {\n  background: #fff;\n  outline: none;\n  border: 1px solid var(--color);\n  box-shadow: 0 0 2px 1px var(--hover-color);\n  appearance: none;\n}\n.mobile_favourite-modal-mobile-container__KaYun .mobile_favourite-modal-mobile-main__VeUUV .mobile_favourite-modal-mobile-input__yYUMl::placeholder {\n  color: #666;\n  font-size: 15px;\n}\n.mobile_favourite-modal-mobile-container__KaYun .mobile_favourite-modal-mobile-text__Dqo7y {\n  font-size: 16px;\n  font-weight: var(--font-weight-medium);\n  letter-spacing: -0.53px;\n  color: #333;\n  margin-bottom: 18px;\n}\n.mobile_favourite-modal-mobile-container__KaYun .mobile_favourite-modal-mobile-save__-CniA {\n  width: 100%;\n  margin-top: 30px;\n}\n.mobile_favourite-modal-mobile-container__KaYun .mobile_favourite-modal-mobile-save__-CniA .mobile_favourite-modal-mobile-button__n7-mw {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  width: 100%;\n  height: 50px;\n  font-size: 18px;\n  font-family: inherit;\n  font-weight: var(--font-weight-medium);\n  letter-spacing: -0.5px;\n  background: var(--color);\n  line-height: 0;\n  text-align: center;\n  padding: 0;\n  margin: 0;\n  color: #fff;\n  border-width: 0;\n  transition: background-color 300ms ease-out;\n  border-radius: 25px;\n  cursor: pointer;\n}\n.mobile_favourite-modal-mobile-container__KaYun .mobile_favourite-modal-mobile-save__-CniA .mobile_favourite-modal-mobile-button__n7-mw:active, .mobile_favourite-modal-mobile-container__KaYun .mobile_favourite-modal-mobile-save__-CniA .mobile_favourite-modal-mobile-button__n7-mw:focus, .mobile_favourite-modal-mobile-container__KaYun .mobile_favourite-modal-mobile-save__-CniA .mobile_favourite-modal-mobile-button__n7-mw:hover {\n  border-color: var(--hover-color);\n  background: var(--hover-color);\n  color: #fff;\n}\n.mobile_favourite-modal-mobile-container__KaYun .mobile_favourite-modal-mobile-save__-CniA .mobile_favourite-modal-mobile-button__n7-mw.mobile_disabled__X2KRm {\n  background: #bbb;\n}\n.mobile_favourite-modal-mobile-container__KaYun .mobile_favourite-modal-mobile-save__-CniA .mobile_favourite-modal-mobile-button__n7-mw.mobile_disabled__X2KRm:active {\n  background: #bbb;\n}\n\n.mobile_sr-only__kTOSh:not(:focus, :active) {\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}";
var styles = {"favourite-modal-mobile-container":"mobile_favourite-modal-mobile-container__KaYun","favourite-modal-mobile-top":"mobile_favourite-modal-mobile-top__SkpP4","favourite-modal-mobile-header":"mobile_favourite-modal-mobile-header__dZlvY","favourite-modal-mobile-main":"mobile_favourite-modal-mobile-main__VeUUV","favourite-modal-mobile-location-search":"mobile_favourite-modal-mobile-location-search__fTM46","favourite-modal-mobile-input":"mobile_favourite-modal-mobile-input__yYUMl","favourite-modal-mobile-text":"mobile_favourite-modal-mobile-text__Dqo7y","favourite-modal-mobile-save":"mobile_favourite-modal-mobile-save__-CniA","favourite-modal-mobile-button":"mobile_favourite-modal-mobile-button__n7-mw","disabled":"mobile_disabled__X2KRm","sr-only":"mobile_sr-only__kTOSh"};
styleInject(css_248z);

/* eslint-disable jsx-a11y/click-events-have-key-events */
const MobileModal = ({
  headerText,
  autosuggestComponent,
  inputPlaceholder,
  specifyName,
  name,
  chooseIconText,
  favouriteIconTable,
  saveFavourite,
  saveText,
  canSave,
  color,
  hoverColor,
  savePlaceText,
  cantSaveText,
  requiredText,
  fontWeights
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles['favourite-modal-mobile-container'],
    style: {
      '--color': `${color}`,
      '--hover-color': `${hoverColor}`,
      '--font-weight-medium': fontWeights.medium
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['favourite-modal-mobile-top']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['favourite-modal-mobile-header']
  }, headerText)), /*#__PURE__*/React.createElement("div", {
    className: styles['favourite-modal-mobile-main']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['favourite-modal-mobile-location-search']
  }, autosuggestComponent), /*#__PURE__*/React.createElement("input", {
    className: styles['favourite-modal-mobile-input'],
    value: name || '',
    placeholder: inputPlaceholder,
    onChange: specifyName
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['favourite-modal-mobile-text']
  }, chooseIconText, /*#__PURE__*/React.createElement("p", {
    className: styles['sr-only']
  }, requiredText)), /*#__PURE__*/React.createElement("div", {
    className: styles['favourite-modal-mobile-icons']
  }, favouriteIconTable), /*#__PURE__*/React.createElement("div", {
    className: styles['favourite-modal-mobile-save']
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: `${styles['favourite-modal-mobile-button']} ${canSave() ? '' : styles.disabled}`,
    onClick: saveFavourite,
    "aria-label": `${canSave() ? savePlaceText : cantSaveText}`
  }, saveText)));
};
process.env.NODE_ENV !== "production" ? MobileModal.propTypes = {
  headerText: PropTypes.string.isRequired,
  autosuggestComponent: PropTypes.node.isRequired,
  inputPlaceholder: PropTypes.string.isRequired,
  specifyName: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  chooseIconText: PropTypes.string.isRequired,
  favouriteIconTable: PropTypes.node.isRequired,
  saveFavourite: PropTypes.func.isRequired,
  saveText: PropTypes.string.isRequired,
  canSave: PropTypes.func.isRequired,
  color: PropTypes.string.isRequired,
  hoverColor: PropTypes.string.isRequired,
  savePlaceText: PropTypes.string.isRequired,
  cantSaveText: PropTypes.string.isRequired,
  requiredText: PropTypes.string.isRequired,
  fontWeights: PropTypes.shape({
    medium: PropTypes.number.isRequired
  }).isRequired
} : void 0;

const _excluded = ["favouriteIconIds"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const FavouriteIconIdToNameMap = {
  'icon-icon_place': 'place',
  'icon-icon_home': 'home',
  'icon-icon_work': 'work',
  'icon-icon_sport': 'sport',
  'icon-icon_school': 'school',
  'icon-icon_shopping': 'shopping'
};
const FavouriteIconTableButton = ({
  value,
  selectedIconId,
  handleClick,
  color,
  lang
}) => {
  const [t] = useTranslation();
  const [isHovered, setHover] = useState(false);
  const [isFocused, setFocus] = useState(false);
  const iconColor = value === FavouriteIconIdToNameMap[selectedIconId] || isHovered || isFocused ? '#ffffff' : color;
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: cx(styles$2['favourite-icon-table-column'], styles$2[value], value === FavouriteIconIdToNameMap[selectedIconId] && styles$2['selected-icon']),
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false),
    onFocus: () => setFocus(true),
    onBlur: () => setFocus(false),
    onClick: () => handleClick(value),
    "aria-label": t(value, {
      lng: lang
    })
  }, /*#__PURE__*/React.createElement(Icon, {
    img: value,
    color: iconColor
  }));
};
process.env.NODE_ENV !== "production" ? FavouriteIconTableButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  selectedIconId: PropTypes.string,
  color: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired
} : void 0;
FavouriteIconTableButton.defaultProps = {
  selectedIconId: ''
};
const FavouriteIconTable = _ref => {
  let {
      favouriteIconIds
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const columns = favouriteIconIds.map(value => /*#__PURE__*/React.createElement(FavouriteIconTableButton, Object.assign({
    key: `favourite-icon-table-${value}`,
    value: value
  }, rest)));
  return /*#__PURE__*/React.createElement("div", {
    className: styles$2['generic-table']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$2.row
  }, columns));
};
process.env.NODE_ENV !== "production" ? FavouriteIconTable.propTypes = {
  favouriteIconIds: PropTypes.arrayOf(PropTypes.string).isRequired
} : void 0;

/**
 * @example
 * <FavouriteModal
 *   show={modalOpen}
 *   handleClose={handleClose}
 *   saveFavourite={onSaveFavourite}
 *   location={selectedLocation}
 *   favourite={favourite}
 *   lang={lang}
 *   autosuggestComponent={
 *     <AutoSuggest
 *       sources={['History', 'Datasource']}
 *       targets={['Locations', 'CurrentPosition']}
 *       id="favourite"
 *       autoFocus={false}
 *       placeholder="search-address-or-place"
 *       value={selectedLocation.address || ''}
 *       onFavouriteSelected={this.setLocationProperties}
 *       lang={lang}
 *     />
 *   }
 * />
 */
class FavouriteModal extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "specifyName", event => {
      const name = event.target.value;
      this.setState(prevState => ({
        favourite: _objectSpread(_objectSpread({}, prevState.favourite), {}, {
          name
        })
      }));
    });
    _defineProperty(this, "selectIcon", id => {
      this.setState(prevState => ({
        favourite: _objectSpread(_objectSpread({}, prevState.favourite), {}, {
          selectedIconId: `icon-icon_${id}`
        })
      }));
    });
    _defineProperty(this, "isEdit", () => this.state.favourite && this.state.favourite.favouriteId !== undefined);
    _defineProperty(this, "canSave", () => this.state.favourite && !isEmpty(this.state.favourite.selectedIconId) && isNumber(this.state.favourite.lat) && isNumber(this.state.favourite.lon));
    _defineProperty(this, "closeModal", () => {
      this.props.handleClose();
      // hsl-fi/modal close animation lasts 250ms
      setTimeout(() => {
        this.setState({
          favourite: null
        });
      }, 250);
    });
    _defineProperty(this, "cancelSelected", () => {
      this.props.cancelSelected();
      // hsl-fi/modal close animation lasts 250ms
      setTimeout(() => {
        this.setState({
          favourite: null
        });
      }, 250);
    });
    _defineProperty(this, "save", () => {
      if (this.canSave()) {
        const name = isEmpty(this.state.favourite.name) ? this.state.favourite.defaultName : this.state.favourite.name;
        const favourite = _objectSpread(_objectSpread({}, this.state.favourite), {}, {
          name
        });
        delete favourite.defaultName;
        this.props.saveFavourite(_objectSpread(_objectSpread({}, favourite), {}, {
          type: 'place'
        }));
        if (this.props.addAnalyticsEvent) {
          this.props.addAnalyticsEvent({
            category: 'Favourite',
            action: 'SaveFavourite',
            name: this.state.favourite.selectedIconId
          });
        }
        if (this.isEdit() && this.props.cancelSelected) {
          this.cancelSelected();
        } else {
          this.closeModal();
        }
      }
    });
    this.state = {
      favourite: null
    };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    const prevFav = prevState.favourite;
    const nextFav = nextProps.favourite;
    if (isEmpty(nextFav)) {
      return {
        favourite: null
      };
    }
    if (isEmpty(prevFav) && !isEmpty(nextFav)) {
      return {
        favourite: _objectSpread({}, nextFav)
      };
    }
    if (!isEmpty(prevFav) && !isEmpty(nextFav) && (nextFav.address !== prevFav.address || nextFav.lat !== prevFav.lat || nextFav.lon !== prevFav.lon)) {
      return {
        favourite: _objectSpread(_objectSpread({}, prevFav), {}, {
          address: nextFav.address,
          lat: nextFav.lat,
          lon: nextFav.lon,
          gid: nextFav.gid || null,
          name: prevFav.name || nextFav.name || '',
          defaultName: nextFav.defaultName
        })
      };
    }
    return null;
  }
  componentWillUnmount() {
    this.setState({
      favourite: null
    });
  }
  render() {
    const {
      favourite
    } = this.state;
    const {
      fontWeights,
      lang,
      t
    } = this.props;
    const {
      primary,
      hover
    } = this.props.colors;
    const headerText = this.isEdit() ? t('edit-place', {
      lng: lang
    }) : t('save-place', {
      lng: lang
    });
    const modalProps = {
      headerText,
      autosuggestComponent: this.props.autosuggestComponent,
      inputPlaceholder: t('input-placeholder', {
        lng: lang
      }),
      specifyName: this.specifyName,
      name: favourite && favourite.name || '',
      chooseIconText: t('choose-icon', {
        lng: lang
      }),
      favouriteIconTable: /*#__PURE__*/React.createElement(FavouriteIconTable, {
        selectedIconId: (() => {
          if (favourite && favourite.selectedIconId !== undefined || null) {
            return favourite.selectedIconId;
          }
          return undefined;
        })(),
        favouriteIconIds: FavouriteModal.favouriteIconIds,
        handleClick: this.selectIcon,
        color: primary,
        lang: lang
      }),
      saveFavourite: this.save,
      saveText: t('save', {
        lng: lang
      }),
      canSave: this.canSave,
      isEdit: this.isEdit(),
      cancelText: t('cancel', {
        lng: lang
      }),
      cancelSelected: () => this.cancelSelected(),
      color: primary,
      hoverColor: hover,
      savePlaceText: t('save-place', {
        lng: lang
      }),
      cantSaveText: t('cannot-save-place', {
        lng: lang
      }),
      requiredText: t('required-text', {
        lng: lang
      }),
      fontWeights
    };
    return /*#__PURE__*/React.createElement(Modal, {
      appElement: this.props.appElement,
      contentLabel: this.isEdit() ? t('favourite-modal-on-edit', {
        lng: lang,
        favourite
      }) : t('favourite-modal-on-add-new', {
        lng: lang
      }),
      closeButtonLabel: t('close-favourite-modal', {
        lng: lang
      }),
      variant: !this.props.isMobile ? 'small' : 'large',
      isOpen: this.props.isModalOpen,
      onCrossClick: () => this.closeModal()
    }, !this.props.isMobile && /*#__PURE__*/React.createElement(DesktopModal, modalProps), this.props.isMobile && /*#__PURE__*/React.createElement(MobileModal, modalProps));
  }
}
_defineProperty(FavouriteModal, "defaultProps", {
  cancelSelected: () => ({}),
  lang: 'fi',
  isMobile: false,
  favourite: null,
  autosuggestComponent: undefined,
  addAnalyticsEvent: undefined,
  colors: defaultColors,
  fontWeights: {
    medium: 500
  }
});
_defineProperty(FavouriteModal, "favouriteIconIds", ['place', 'home', 'work', 'sport', 'school', 'shopping']);
process.env.NODE_ENV !== "production" ? FavouriteModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  /** Required.
   * @type{function} */
  handleClose: PropTypes.func.isRequired,
  /** Required.
   * @type{function} */
  saveFavourite: PropTypes.func.isRequired,
  /** Required. Only used when editing favourite.
   * @type{function} */
  cancelSelected: PropTypes.func,
  /** Optional.
   * Autosuggest component for searching new favourites.
   * @type{node}
   */
  autosuggestComponent: PropTypes.node,
  /** Optional.
   * Object to prefill input field for name and/or selected icon.
   * @type {object}
   * @property {string} type
   * @property {string} address
   * @property {string} gtfsId
   * @property {string} gid
   * @property {number} lat
   * @property {number} lon
   * @property {string} name
   * @property {string} selectedIconId
   * @property {string} favouriteId
   * @property {string} layer
   * @property {string} defaultName
   */
  favourite: PropTypes.shape({
    type: PropTypes.string,
    address: PropTypes.string,
    gtfsId: PropTypes.string,
    gid: PropTypes.string,
    lat: PropTypes.number,
    lon: PropTypes.number,
    name: PropTypes.string,
    selectedIconId: PropTypes.string,
    favouriteId: PropTypes.string,
    layer: PropTypes.string,
    defaultName: PropTypes.string
  }),
  /** Optional.
   * @type {function} */
  addAnalyticsEvent: PropTypes.func,
  /** Optional. Language, fi, en or sv.
   * @type {string} */
  lang: PropTypes.string,
  /** Translation function */
  t: PropTypes.func.isRequired,
  /** Optional. */
  isMobile: PropTypes.bool,
  appElement: PropTypes.string.isRequired,
  colors: PropTypes.objectOf(PropTypes.string),
  /** Optional. */
  fontWeights: PropTypes.shape({
    /** Default value is 500. */
    medium: PropTypes.number
  })
} : void 0;
const FavouriteModalWithTranslation = withTranslation()(FavouriteModal);
var index = props => /*#__PURE__*/React.createElement(I18nextProvider, {
  i18n: i18n
}, /*#__PURE__*/React.createElement(FavouriteModalWithTranslation, props));

export { index as default };
//# sourceMappingURL=index.js.map
